export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const TOGGLE_CART_HIDDEN = "TOGGLE_CART_HIDDEN";
export const ADD_ITEM = "ADD_ITEM";
export const REMOVE_ITEM = "REMOVE_ITEM";
export const DECREASE_QUANTITY = "DECREASE_QUANTITY";
export const INCREASE_QUANTITY = "INCREASE_QUANTITY";
export const INITIALIZE_STRIPE = "INITIALIZE_STRIPE";
export const SET_ERROR = "SET_ERROR";
export const SET_LOADING = "SET_LOADING";
export const SET_COLLECTIONS = "SET_COLLECTIONS";
export const SET_COLLECTIONS_AND_ITEMS = "SET_COLLECTIONS_AND_ITEMS";
